import React from 'react';

// Контекст для управления переходом в Fullscreen.
export interface FullscreenContextOptions {
    setFullscreenActive(): void;
}

export const FullscreenContext = React.createContext<FullscreenContextOptions>({
    setFullscreenActive: () => {
        return;
    },
});
